import { isPendingAssistantText } from '@/constants/chat'

export function hasUnresolvedAssistant(messages = []) {
  const tail = messages[messages.length - 1]
  if (tail?.role !== 'assistant') return false
  return Boolean(
    isPendingAssistantText(tail.text ?? '') ||
      tail.demoStreamActive ||
      tail.phase1Interrupted,
  )
}
